export const routes = {
  auth: {
    login: '/auth/local',
    refresh: '/auth/refresh',
    impersonateStop: '/auth/impersonate/stop',
    forgotPassword: '/auth/forgot-password',
    resetPassword: '/auth/reset-password',
    changePassword: '/auth/change-password',
    firstAccess: '/auth/first-access',
  },
  courses: {
    base: '/courses',
    search: '/courses/search',
    groupedByCategory: '/courses/grouped-by-category',
    one: (id: string) => `/courses/${id}`,
    enroll: (id: string) => `/courses/${id}/enroll`,
    progress: (id: string) => `/courses/${id}/progress`,
    complete: (id: string) => `/courses/${id}/complete`,
    me: '/courses/me/enrollments',
    recommendations: '/courses/me/recommendations',
  },
  categories: {
    base: '/categories',
    search: '/categories/search',
    one: (id: string) => `/categories/${id}`,
  },
  tracks: {
    base: '/tracks',
    search: '/tracks/search',
    one: (id: string) => `/tracks/${id}`,
    courses: (trackId: string) => `/tracks/${trackId}/courses`,
  },
  modules: {
    base: '/modules',
    search: '/modules/search',
    classesByModuleIds: '/modules/classes/by-module-ids',
    one: (id: string) => `/modules/${id}`,
  },
  contents: {
    base: '/contents',
    search: '/contents/search',
    one: (id: string) => `/contents/${id}`,
  },
  certificates: {
    me: '/certificates/me',
    one: (id: string) => `/certificates/${id}`,
    download: (id: string) => `/certificates/${id}/download`,
    issue: (courseId: string) => `/certificates/courses/${courseId}`,
  },
  users: {
    base: '/users',
    me: '/users/me',
    one: (id: string) => `/users/${id}`,
    status: (id: string) => `/users/${id}/status`
  },
  medias: {
    presigned: '/medias/presigned/',
    presignedByFile: '/medias/presigned/{asset}/{file}',
    images: '/medias/images',
  }
};
